import { useState } from "react";
import { useTranslation } from "react-i18next";

const ServeNoticePopup = ({ handleServeNotice, heading }) => {

    const { t } = useTranslation()

    const [DDLID, setDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const options = [
        { id: 1, value: 1, label: '1' },
        { id: 2, value: 2, label: '2' },
    ]

    return (
        <>
            <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content p-3">
                        <div className="modal-header pt-0">

                            <h5 className="card-title fw-bold" id="exampleModalLongTitle">
                                {heading}
                            </h5>
                            <button onClick={() => handleServeNotice()} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">

                            <div className="row" >
                                <div className="col-12  " >
                                    <div className="table-responsive pt-3">
                                        <table className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.date')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.Photo')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.OfficerName')}</th>

                                                </tr>

                                            </thead>
                                            <tbody>

                                                <tr>
                                                    <td className="py-1" align="center">1</td>
                                                    <td className="text-center"></td>
                                                    <td className="text-center">
                                                        <span className="cursor-pointer">
                                                            <i class="fa-solid fa-image text-danger"></i>
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        {/* <span className="view_button">
                                                            {t('EncroachmentDashboard.View')}
                                                        </span> */}
                                                    </td>


                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>

                                </div>




                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="row">
                                {/* <div className="col-12 pt-3">
                                    <button
                                        type='button'
                                        // onClick={() => confirmBtnCallBack(deleteRecord)}
                                        className="w-80 btn addbtn btn-success btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                       
                                        {t('EncroachmentDashboard.Forward')}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleSiteVerificationDetails}
                                        className="w-80  btn addbtn btn-danger btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                        <i class="fa-solid fa-xmark pe-1"></i> Cancel

                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>);
}

export default ServeNoticePopup;